import { render, staticRenderFns } from "./SingleRankingTaskPage.vue?vue&type=template&id=ebabe742&scoped=true&"
import script from "./SingleRankingTaskPage.vue?vue&type=script&lang=ts&"
export * from "./SingleRankingTaskPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebabe742",
  null
  
)

export default component.exports